import { Component, Input } from '@angular/core';
import { HomrCaliaCarouselSlide, IHomrRichContent } from '@shared/data-access/interfaces';

import { DCSG_CONSTANTS } from '@shared/data-access/constants';
import { Observable } from 'rxjs';
import { Store } from '@shared/data-access/services';
import { UriDecodePipe } from '@shared/utils/pipes';
import { UtilityService } from '@shared/utils/services';
import { map } from 'rxjs/operators';

@Component({
    selector: 'pdp-homr-calia-leggings-content',
    templateUrl: './homr-calia-leggings-content.component.html',
    styleUrls: ['./homr-calia-leggings-content.component.scss'],
    standalone: false
})
export class HomrCaliaLeggingsContentComponent {
	@Input() lazyLoadImages = false;
	enhancedProductCardContent$: Observable<HomrCaliaCarouselSlide[]>;
	slideAmount$: Observable<number>;
	fallbackImage = DCSG_CONSTANTS.imageUnavailable;
	currentSlideIndex = 1;
	decodeURIPipe = new UriDecodePipe();

	constructor(private store: Store, public utilityService: UtilityService) {
		this.enhancedProductCardContent$ = this.store.selectDistinctKey('HOMR_DATA').pipe(
			map((data: { homrRichContent: IHomrRichContent }) => data.homrRichContent.enhancedProductCard)
		);

		this.slideAmount$ = this.enhancedProductCardContent$.pipe(map((content) => content.length));
	}

	trackBySlide(index: number, item: HomrCaliaCarouselSlide): string {
		return index.toString() + item.title;
	}

}
